import { assoc, compose, map, pick } from 'ramda'

export const cleanRequest = form => {
  return compose(
    pick([
      'id',
      'name',
      'amount',
      'warningAmount',
      'criticalAmount',
      'code',
      'description',
      'category',
      'subCategory',
      'brand',
      'model',
      'supplier',
      'sizeUnit',
      'minAmount',
      'maxAmount',
      'location',
      'purchaseTax',
      'purchasePrice',
      'salesPrice',
      'maxDiscount',
      'salesTax',
      'currency',
      'barCode',
      'notes',
      'documents',
      'notificationEmails'
    ]),
    item => assoc('amount', Number(item.amount || 0), item),
    item => assoc('warningAmount', Number(item.warningAmount), item),
    item => assoc('criticalAmount', Number(item.criticalAmount), item),
    item => assoc('minAmount', Number(item.minAmount), item),
    item => assoc('maxAmount', Number(item.maxAmount), item),
    item => assoc('purchasePrice', Number(item.purchasePrice), item),
    item => assoc('purchaseTax', Number(item.purchaseTax), item),
    item => assoc('salesPrice', Number(item.salesPrice), item),
    item => assoc('maxDiscount', Number(item.maxDiscount), item),
    item => assoc('salesTax', Number(item.salesTax), item),
    item => assoc('documents', map(pick(['id', 'description']), item.documents || []), item),
    item =>
      assoc(
        'notificationEmails',
        item.notificationEmails
          ?.split(';')
          ?.map(e => e.trim())
          ?.filter(Boolean),
        item
      )
  )(form)
}
